export const locale = {
  lang: 'en',
  data: {
    helpTopic: {
      notifications: {
        save: `Saving help topic in progress ...`
      }
    }
  }
};
